// =====================================================================
//  VIDEO GALLERY DATA  —  Biswajit Dey Portfolio
// ---------------------------------------------------------------------
//  HOW TO SWAP IN YOUR REAL LINKS:
//  1. Replace `youtubeId` with the ID from your YouTube URL.
//     e.g. https://www.youtube.com/watch?v=ABC123xyz  ->  youtubeId: "ABC123xyz"
//  2. (Optional) Replace `poster` with your own thumbnail URL, or leave blank
//     to auto-use the YouTube thumbnail.
//  3. `category` controls which section a clip appears in:
//        "branded"      -> shows in All Work + Branded Content
//        "documentary"  -> shows in All Work
//        "commercial"   -> shows in All Work + Branded Content
//  4. `featured: true` gives the clip a larger tile in the bento grid.
// =====================================================================

export const videos = [
  {
    id: "wk-00",
    title: "Borderlands",
    client: "National Award-Winning Documentary (2022)",
    role: "Bengali Section Content Producer",
    category: "documentary",
    youtubeId: "6KKDkFo1IQ8",
    duration: "Feature Documentary",
    year: "2022",
    featured: true,
  },
  {
    id: "wk-01",
    title: "Masters of Kota",
    client: "Original Mini-Documentary",
    role: "Post-Production Lead",
    category: "documentary",
    youtubeId: "5CaZ0GmrMCg",
    duration: "Mini Documentary",
    year: "2024",
    featured: true,
  },
  {
    id: "wk-02",
    title: "Dassault Systèmes — Brand Film",
    client: "Dassault",
    role: "Producer",
    category: "branded",
    youtubeId: "Jdq1qiUfvLI",
    duration: "Brand Film",
    year: "2024",
    featured: false,
  },
  {
    id: "wk-03",
    title: "Startup India — Campaign Series",
    client: "Startup India",
    role: "Producer",
    category: "branded",
    youtubeId: "qjELnqtZPic",
    duration: "Campaign Series",
    year: "2023",
    featured: false,
  },
  {
    id: "wk-04",
    title: "Meta × Ministry of Information & Broadcasting",
    client: "Meta · Government of India",
    role: "Producer",
    category: "branded",
    youtubeId: "L71w3iiZoW8",
    duration: "National Campaign",
    year: "2024",
    featured: false,
  },
  {
    id: "wk-05",
    title: "SheSpark — Live Event Coverage",
    client: "SheSpark",
    role: "Multi-Cam Director",
    category: "commercial",
    youtubeId: "bDRn3nu8SNk",
    duration: "Live Multi-Cam",
    year: "2023",
    featured: false,
  },
  {
    id: "wk-06",
    title: "Taj Safaris — Give In To Adventure",
    client: "Taj Hotels & Resorts",
    role: "Producer / Editor",
    category: "branded",
    youtubeId: "gs4PsYg7heE",
    duration: "Brand Film",
    year: "2022",
    featured: false,
  },
  {
    id: "wk-07",
    title: "Regional Music Video — Promo I",
    client: "Regional Release",
    role: "Promotion Design & Creative Direction",
    category: "music video",
    youtubeId: "7yLj6ilDDBo",
    duration: "Music Video",
    year: "2023",
    featured: false,
  },
  {
    id: "wk-08",
    title: "Regional Music Video — Promo II",
    client: "Regional Release",
    role: "Promotion Design & Creative Direction",
    category: "music video",
    youtubeId: "7hCgIwnVC2w",
    duration: "Music Video",
    year: "2023",
    featured: false,
  },
  {
    id: "wk-09",
    title: "Regional Music Video — Promo III",
    client: "Regional Release",
    role: "Promotion Design & Creative Direction",
    category: "music video",
    youtubeId: "51z4oIHEPOI",
    duration: "Music Video",
    year: "2023",
    featured: false,
  },
  {
    id: "wk-10",
    title: "Brand Campaign — Concept to Cut",
    client: "Social Campaign",
    role: "Creative · Edit · Concept",
    category: "campaign",
    youtubeId: "4FHT4rakRRE",
    duration: "Campaign",
    year: "2024",
    featured: false,
  },
  {
    id: "wk-11",
    title: "Social Campaign Film",
    client: "Social",
    role: "Producer · Editor",
    category: "branded",
    youtubeId: "rM-ioXKyTmA",
    duration: "Social Film",
    year: "2024",
    featured: false,
  },
];

// Vertical / social-first content. Sources: Google Drive (AI) + Instagram reels.
const ig = (instaCode, category, role) => ({
  id: `ig-${instaCode}`,
  provider: "instagram",
  instaCode,
  category,
  role,
});

const drv = (driveId, role) => ({
  id: `drv-${driveId.slice(0, 8)}`,
  provider: "drive",
  driveId,
  poster: `https://drive.google.com/thumbnail?id=${driveId}&sz=w1000`,
  category: "AI Content",
  role,
  ai: true,
  label: "AI-Generated",
  note: "Concept, script & production — start to finish",
});

// Big-sharks helper — long-form founder/leader interviews on YouTube.
const bigYt = (youtubeId, label, note, role = "Producer · Script · Edit") => ({
  id: `bs-yt-${youtubeId}`,
  provider: "youtube",
  youtubeId,
  category: "Big Sharks",
  role,
  label,
  note,
});

// Big-sharks helper — Drive-hosted long-form interview.
const bigDrv = (driveId, label, note, role = "Producer · Script · Edit") => ({
  id: `bs-drv-${driveId.slice(0, 8)}`,
  provider: "drive",
  driveId,
  poster: `https://drive.google.com/thumbnail?id=${driveId}&sz=w1000`,
  category: "Big Sharks",
  role,
  label,
  note,
});

export const socialReels = [
  // Mastercard
  ig("DRRjIiuj9T6", "Mastercard", "Producer · Editor · Shoot"),
  ig("DRROMEPjsaB", "Mastercard", "Producer · Editor · Shoot"),
  ig("DRPa8M5kYBi", "Mastercard", "Producer · Editor · Shoot"),

  // On-camera
  ig("DQWl1m9Eh_7", "Live & On-Camera", "Producer · Host"),
  ig("DQOUbRADMfM", "Live & On-Camera", "Producer · Host"),
  ig("DQg48H5EZ2W", "Live & On-Camera", "Producer · Moderator"),

  // Changemaker Stories
  ig("DTiKfAGEenK", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUF8rTTioYn", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUIV1eDDWeH", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUVGrdbjXeh", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUki9lIjRyl", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUh-kzSjWcK", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUaOljQih8M", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUXt5whCm9q", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUnIpTbDfJG", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUpr8b_jSmt", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DUsc9DZDYSS", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DU3CHZrDGb-", "Changemaker Stories", "Producer · Post-Production Supervisor"),
  ig("DVIeQDiEZMO", "Changemaker Stories", "Producer · Post-Production Supervisor"),

  // One District One Product
  ig("DVLe34CiDDk", "One District One Product", "Post Producer"),
  ig("DVaSBriiBa-", "One District One Product", "Post Producer"),
  ig("DWJYUzxCKay", "One District One Product", "Post Producer"),
  ig("DVOD3U-CGdh", "One District One Product", "Post Producer"),

  // Entrepreneur Stories
  ig("DVl0pAOjGFW", "Entrepreneur Stories", "Script · Post-Production Supervision"),
  ig("DVjMG2VjDNa", "Entrepreneur Stories", "Script · Post-Production Supervision"),

  // AI Content — placed last since it has the fewest items
  drv("1eRdr7szYygClOh11db2B5SL0VOCTuOsZ", "End-to-End Production · Script to Final Cut"),
  drv("19HFyA3lU9J_aC-RtYxnumNPfl4Um5TPC", "End-to-End Production · Script to Final Cut"),
];

// Big Sharks — long-form founder & leader interviews, shown as its own section
// above Social First Content.
export const bigSharks = [
  bigYt(
    "D40ezSIZSj0",
    "Ronnie Screwvala",
    "On AI, education & India's $10T dream"
  ),
  bigDrv(
    "1aqOr666f1cB828xACp4WB37zh36sCdQj",
    "Jyotiraditya Scindia",
    "Minister of Communications of India"
  ),
  bigYt(
    "Jdq1qiUfvLI",
    "Dassault Systèmes",
    "Building the future of engineering in India"
  ),
  bigYt(
    "YudHrWMKAdM",
    "AI for Founders & Marketers",
    "What AI means for one-person businesses"
  ),
  bigYt(
    "ihfxtMtd-Mw",
    "Pawan Kumar Chandana · Skyroot",
    "Reached orbit — now the hard part"
  ),
  bigYt(
    "RnxbC5BZUV8",
    "Sanjay Jaju · Ministry of I&B",
    "The future of India's media"
  ),
  bigYt(
    "QpfkBSJXL-Q",
    "Vande Mataram to Nalanda",
    "India's lost heritage and cultural soul"
  ),
  bigYt(
    "7cqZsvxn5uY",
    "Zupee × Salman Khan",
    "Ludo campaign — win laakhon tak cash"
  ),
  bigYt(
    "XwK-dDpVkvc",
    "Global Christmas Wishes",
    "ByteDance family — a global holiday film"
  ),
];

// Zupee campaign — individual video deliverables displayed as an auto-slide
// gallery inside the Creative Campaigns card. Each tile is clickable.
export const zupeeCampaignVideos = [
  { youtubeId: "cSvIw8KQfS0" },
  { youtubeId: "-6WV3zENvsE" },
  { youtubeId: "kCRJh6qmH40" },
  { youtubeId: "a2ugPnQJkNU" },
  { youtubeId: "vnfLsek7Ees" },
  { youtubeId: "bJZh6CoQOQA" },
  { youtubeId: "to-afb_fKAo" },
  { youtubeId: "7cqZsvxn5uY" },
  { youtubeId: "4t1JJYKDBS4" },
];

export const youtubeThumb = (id) =>
  `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;

// Ordered fallback chain — YouTube guarantees `hqdefault` for every public video.
export const YT_THUMB_TIERS = [
  "maxresdefault",
  "sddefault",
  "hqdefault",
  "mqdefault",
  "default",
];

export const youtubeThumbAt = (id, tier) =>
  `https://i.ytimg.com/vi/${id}/${tier}.jpg`;

export const youtubeThumbFallback = (id) =>
  `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

export const youtubeEmbed = (id) =>
  `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;

export const driveEmbed = (id) =>
  `https://drive.google.com/file/d/${id}/preview`;

export const driveThumb = (id) =>
  `https://drive.google.com/thumbnail?id=${id}&sz=w1000`;

export const instaEmbed = (code) =>
  `https://www.instagram.com/reel/${code}/embed`;

export const instaUrl = (code) =>
  `https://www.instagram.com/reel/${code}/`;

// Poster fallback for AI / drive reels when the Drive thumbnail is blocked.
export const AI_POSTER_FALLBACK =
  "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&w=700&q=80";

// =====================================================================
//  CASE STUDIES  —  Click-to-view PDFs hosted on Google Drive.
//  To add a new one, drop the driveId (from https://drive.google.com/file/d/<ID>/view)
//  and give it a short title/client. That's it — it appears in the Case Studies tab.
// =====================================================================
export const caseStudies = [
  { id: "cs-01", driveId: "186GOIyuAan6zia7EiZ4C1ZFfg-TAUV82", title: "Business Startup Checklist", client: "Idea to Launch", year: "2024", pages: "PDF" },
  { id: "cs-02", driveId: "1GObrsop4naYuMR8bvhI5YAp1IWngdTRe", title: "Competitor Analysis Playbook", client: "Storytelling edition", year: "2024", pages: "PDF" },
  { id: "cs-03", driveId: "1weYBxvqIDrWJAx8u9N85mmdlvgCHAEG3", title: "Fashion with a Conscience", client: "Sustainable fashion", year: "2024", pages: "PDF" },
  { id: "cs-04", driveId: "14hiRS1DOiuNrLTo3ds-k4dX7-cjC005n", title: "Fundraising Playbook", client: "Founder's guide", year: "2024", pages: "PDF" },
  { id: "cs-05", driveId: "1pp6hFdr3lZngZAsviVqHQzlzXFfUl4sf", title: "Growth Hacking in India", client: "Scale to ₹1 Crore faster", year: "2024", pages: "PDF" },
  { id: "cs-06", driveId: "1h0qYKURorcAL3vqdrku6D8dIFJ8iPytk", title: "How Indian Entrepreneurs Build an MVP", client: "MVP playbook", year: "2024", pages: "PDF" },
  { id: "cs-07", driveId: "1q4KSVh675kkMXiHnnbW_3bk_f5BI6hZ9", title: "How to Build a Unique Brand", client: "Brand strategy", year: "2024", pages: "PDF" },
  { id: "cs-08", driveId: "1K1id9kfYxaGTLP76nNhOtbbacohShcPe", title: "The Business Plan That Works", client: "Writing guide", year: "2024", pages: "PDF" },
  { id: "cs-09", driveId: "156I2UTPDbJ9oY-l9bqd4jyKB9wCUy427", title: "Import & Export Playbook", client: "Trade handbook", year: "2024", pages: "PDF" },
  { id: "cs-10", driveId: "136v0Ic9Z-xZqH3X3fF9XK27H6QGBrwsQ", title: "Risk Management Playbook", client: "Operational resilience", year: "2024", pages: "PDF" },
  { id: "cs-11", driveId: "1WJimGmBpd4LKmuEwGR_ivx0_0q3Fpi8z", title: "The AI Marketing Playbook", client: "AI for marketers", year: "2024", pages: "PDF" },
  { id: "cs-12", driveId: "1-J9PXte-dIhw2tqVjLlgtkONZS9bXgXb", title: "The EV Paradox", client: "India's battery waste crisis", year: "2024", pages: "PDF" },
  { id: "cs-13", driveId: "1D8d6GrvgWd4aG_7zeX1F8IiucHw1J2ls", title: "The Pitch Deck That Gets Funded", client: "Investor playbook", year: "2024", pages: "PDF" },
  { id: "cs-14", driveId: "1u-pVbofgaopOO0mY8K7JCLfoVJ9rX1y-", title: "Government Schemes for Entrepreneurs", client: "Policy & funding guide", year: "2024", pages: "PDF" },
];

export const drivePdfEmbed = (id) =>
  `https://drive.google.com/file/d/${id}/preview`;

export const driveOpenUrl = (id) =>
  `https://drive.google.com/file/d/${id}/view`;
